export const LeadNotificationServiceIds = ['39', '76', '116'];

export const LeadNotificationRoute = {
  LEADNOTIFICATIONS: 'leadnotifications',
};

export const LeadNotificationPathName = {
  LEADNOTIFICATIONS: 'leadnotifications',
  LEADNOTIFICATIONFORM_NEW: 'leadnotificationform:new',
  LEADNOTIFICATIONFORM: 'leadnotificationform',
};
